
import { lighten } from 'polished';
import styled from 'styled-components';

interface ContainerProps {
  bgImage: string;
  bgPosition: string;
}


export const Container = styled.div<ContainerProps>`
  width: 100%;
  height: 86vh;
  background-image: url(${props => props.bgImage});
  background-position: ${props => props.bgPosition};
  /* background-position: top bottom; */
	background-size: cover;
	background-repeat: no-repeat;
  padding: 150px 0px 20px 0px;  
  /* animation: mymove 3s linear; */
  transition: all 1s ease-in;

  /* -webkit-animation: mymove 3s linear infinite;
  -moz-animation: mymove 3s linear infinite;
  animation: mymove 3s linear infinite;  */

  -webkit-backface-visibility: hidden;
  -moz-backface-visibility:    hidden;
  -ms-backface-visibility:     hidden;
  -webkit-transform: translate3d(0, 0, 0);

  /* Standard syntax */
  /* @keyframes mymove {
    from {
      background-position: top 
    }

    to {
      background-position: bottom 
    } 
  }
  
  @-webkit-keyframes mymove {
    from {
      background-position: top 
    }

    to {
      background-position: bottom 
    } 
  } */
`;


export const JoinButton = styled.div`
  @media (max-width: 1024px) {
    font-size: 20px;
    width: 90vw;
  }

  color: #B19143;
  /* color: #B19143; */
  padding: 10px 0;
  width: 250px;
  font-family: 'Oswald', sans-serif;
  letter-spacing: 2px;
  font-size: 18px;
  background-color: #11233E;
  /* background-color: rgba(255, 255, 255, 0.9); */
  text-align: center;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 1px 1px 3px black;
  border: 1px solid #B19143;
  transition: all 0.5s;
  display: flex;
  align-items: center;

  svg {
    margin: 0 10px 0 15px;
    padding-bottom: 3px;
    color: #B19143;
  }

  &:hover {
    color:  ${lighten(0.1, '#fff')};
    transition: all 0.5s;

    svg {
      color:  ${lighten(0.1, '#fff')};
      transition: all 1s;
    }
  }
`;

